import { useEffect, useMemo } from 'react';

import { ADDRESSES_LIMIT, MIXED_TRANSPORT_METHOD } from 'appConstants';
import { useAddresses } from 'contexts/Addresses';
import SingleSelectField from 'fields/SingleSelectField';

import type { IDeliveryAddressField } from './types';
import { displayAddress } from 'utils';

const DeliveryAddressField = ({
  disabled,
  name,
  label,
  placeholder,
  noOptionsFoundText,
  customerReference,
  transportMethod,
  onChange,
  required,
}: IDeliveryAddressField) => {
  const {
    state: { addresses, loading, loaded, error },
    actions: { loadAddresses, resetAddresses },
  } = useAddresses();

  useEffect(() => {
    if (customerReference && !loaded && !loading && !error) {
      loadAddresses({ limit: ADDRESSES_LIMIT, customer: customerReference });
    }
  }, [customerReference, loadAddresses, loaded, loading, error]);

  useEffect(() => {
    if (!customerReference && loaded) {
      resetAddresses();
    }
  }, [customerReference, loaded, resetAddresses]);

  const options = useMemo(
    () =>
      addresses
        .filter((address) =>
          [transportMethod, MIXED_TRANSPORT_METHOD].includes(address.movementRestriction),
        )
        .map((address) => ({
          value: address.addressNumber,
          label: displayAddress(address),
        })),
    [addresses, transportMethod],
  );

  return (
    <SingleSelectField
      required={required}
      data-testid="delivery-adress-field"
      loading={loading}
      disabled={disabled}
      name={name}
      label={label}
      placeholder={placeholder}
      noOptionsFoundText={noOptionsFoundText}
      options={options}
      onChange={onChange}
      autoWidth={false}
    />
  );
};
export default DeliveryAddressField;
